__turbopack_context__.v({
  "className": "barlow_c4c5db1b-module__PDWffa__className",
});
